import React from 'react'

import {
  Dropdown,
  type DropdownItemProps,
  Icon,
  type IconComponent,
  useMediaQueryContext,
} from '@fourthwall/components'

import * as S from './QuickActionsDropdownItem.styled'

interface QuickActionsDropdownItemProps extends Omit<DropdownItemProps, 'label'> {
  title: string
  subtitle: string
  icon: IconComponent
}

export const QuickActionsDropdownItem = ({
  title,
  subtitle,
  icon,
  ...props
}: QuickActionsDropdownItemProps) => {
  const media = useMediaQueryContext()

  return (
    <Dropdown.Item
      label={
        <S.Container>
          <S.IconWrapper>
            <Icon component={icon} height={media.tablet ? 18 : 20} />
          </S.IconWrapper>
          <S.ContentWrapper>
            <S.Title>{title}</S.Title>
            <S.Subtitle>{subtitle}</S.Subtitle>
          </S.ContentWrapper>
        </S.Container>
      }
      {...props}
    />
  )
}
